"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSame = exports.getFilteredOptions = exports.doesSameExist = exports.anyWordMatches = void 0;
var _listboxUtils = require("../List/_listboxUtils");
var _isFunction = require("../utils/isFunction");
// returns true if any word in a sentence (case insensitive) matches the searchString using
// provided matcherMethod.
const anyWordMatches = (sentence, searchString, matcherMethod = 'startsWith') => {
  var _a;
  if ((0, _isFunction.isFunction)(sentence === null || sentence === void 0 ? void 0 : sentence.split)) {
    const words = sentence.split(/\s/i);
    return (words === null || words === void 0 ? void 0 : words.length) && !!((_a = words === null || words === void 0 ? void 0 : words.find(word => (0, _listboxUtils.matcherMethodIgnoreCase)(word, searchString, matcherMethod))) === null || _a === void 0 ? void 0 : _a.length);
  }
  return false;
};
// if non-empty string: returns props.options for which
// any word in option.text begins with searchString, case insensitive
//
// if empty search string: returns entire the props.options array
exports.anyWordMatches = anyWordMatches;
const getFilteredOptions = ({
  searchString,
  options,
  itemText,
  matcherMethod = 'startsWith'
}) => {
  var _a;
  if ((_a = searchString === null || searchString === void 0 ? void 0 : searchString.trim()) === null || _a === void 0 ? void 0 : _a.length) {
    return options === null || options === void 0 ? void 0 : options.filter(eachOption => {
      var _a;
      return ((_a = searchString === null || searchString === void 0 ? void 0 : searchString.toLowerCase().match(/\s/i)) === null || _a === void 0 ? void 0 : _a.length // if search string has white space
      ) ?
      // treat as one word
      (0, _listboxUtils.matcherMethodIgnoreCase)((0, _listboxUtils.reduceOption)(eachOption, itemText), searchString, matcherMethod) :
      // treat as sentence
      anyWordMatches((0, _listboxUtils.reduceOption)(eachOption, itemText), searchString, matcherMethod);
    });
  }
  return options;
};
// return true if 2 combobox options have the same key value.
exports.getFilteredOptions = getFilteredOptions;
const isSame = (option1, option2, itemKey) => (0, _listboxUtils.reduceOption)(option1, itemKey) === (0, _listboxUtils.reduceOption)(option2, itemKey);
// return true if the key of option1 exists in any of the options in the array
exports.isSame = isSame;
const doesSameExist = (option1, optionArr, itemKey) => {
  const option1Key = (0, _listboxUtils.reduceOption)(option1, itemKey);
  const optionArray = Array.isArray(optionArr) ? optionArr : [optionArr];
  return optionArray.some(option => (0, _listboxUtils.reduceOption)(option, itemKey) === option1Key);
};
exports.doesSameExist = doesSameExist;